// for map define some key and related information
export const rangeMapping = {
  gross_enrollment_ratio: ["<=50", "50.1-60.0", "60.1-70.0", "70"],
  dropout_rate: ["15+", "10.1-15.0", "5.1-10.0", "0-5.0"],
  dropout_ratio: ["0-3", "3.1-5.0", "5.1-8.0", "8"],
  transition_rate: ["<=85", "85.1-90.0", "90.1-95.0", "95"],
  pupil_teacher_ratio: ["40+", "35-40", "31-35", "30 and Below"],
  schools_with_drinking_water: ["<=85", "85.01-90.00", "90.01-95.00", "95"],
  schools_with_electricity_connection: [
    "<=70",
    "70.01-80.00",
    "80.01-90.00",
    "90",
  ],
  toilet: ["<=85", "85.01-90.00", "90.01-95.00", "95"],
  libraries: ["<=50", "51.01-70.00", "71.01-90.00", "90"],
  ramp: ["<=50", "51.01-70.00", "71.01-90.00", "90"],
  nature_of_appointment: ["<=30", "30.01-50.00", "50.01-80.00", "80"],
  trained_teacher_for_cwsn: ["<=3", "3.01-5.00", "5.01-8.00", "8"],
  "teacher_trained_&_teaching_through_computer": [
    "<=30",
    "30.01-50.00",
    "50.01-80.00",
    "80",
  ],
  gender_parity_index: ["Below 0.90", "0.90-0.95", "0.96-0.99", "1.00 onwards"],
};

export const keyMap = {
  gross_enrollment_ratio: {
    middle: "gerSec",
    secondary: "gerHSec",
  },
  dropout_rate: {
    preparatory: "dropoutPry",
    secondary: "dropoutSec",
  },
  transition_rate: {
    preparatoryToMiddle: "transPryUPry",
    preparatoryMiddleToSec: "transUPrySec",
  },
  pupil_teacher_ratio: {
    pupilPreparatory: "ptrUPry",
    pupilMiddle: "ptrSec",
  },
  schools_with_drinking_water: {
    default: "schWithDrinkWater",
  },
  schools_with_electricity_connection: {
    default: "schWithElectricity",
  },
  toilet: {
    girls: "totSchGToilet",
    boys: "totSchBToilet",
  },
  libraries: {
    default: "totSchLibrary",
  },
  ramp: {
    default: "totSchRamp",
  },
  nature_of_appointment: {
    female: "totTchFModify",
    male: "totTchMModify",
  },
  trained_teacher_for_cwsn: {
    female: "totTchCWSNTrainedF",
    male: "totTchCWSNTrainedM",
  },
  "teacher_trained_&_teaching_through_computer": {
    female: "totTchCompTrainedF",
    male: "totTchCompTrainedM",
  },
  gender_parity_index: {
    gpiprimary: "gpiPry",
    gpiUpperPrimary: "gpiUPry",
    elementary: "gpiElementary",
    gpiSecondary: "gpiSec",
  },
  dropout_ratio: {
    gerDropoutUpperPrimary: "dropoutUPry",
    gerDropoutSecondary: "dropoutSec",
  },
};

export const keyLabels = {
  gerSec: "Gross Enrollment Ratio Middle",
  gerHSec: "Gross Enrollment Ratio Secondary",
  dropoutPry: "Dropout Rate Preparatory",
  dropoutSec: "Dropout Rate Secondary",
  transPryUPry: "Transition Rate Preparatory to Middle",
  transUPrySec: "Transition Rate Middle to secondary",
  ptrPry: "Pupil Teacher Ratio Preparatory",
  ptrSec: "Pupil Teacher Ratio Middle",
  ptrUPry: "Pupil Teacher Ratio Preparatory",
  schWithDrinkWater: "Schools with Drinking Water",
  schWithElectricity: "Schools with Electricity Connection",
  totSchGToilet: "Toilet Girls",
  totSchBToilet: "Toilet Boys",
  totSchLibrary: "Libraries",
  totSchRamp: "Ramp",
  totTchFModify: "Female",
  totTchFModify: "Male",
  totTchCWSNTrainedF: "Female",
  totTchCWSNTrainedM: "Male",
  totTchCompTrainedF: "Female",
  totTchCompTrainedM: "Male",
  gpiPry: "Foundational",
  gpiUPry : "Preparatory",
  gpiElementary: "Middle",
  gpiSec :"Secondary",
  dropoutUPry : "Middle", 

};
